export default "/static/assets/arrow_left.29b156d1d4a3a53a8dc822ab5f014661.svg";